import Vue from "vue";
import VueRouter from "vue-router";
import { authGuard } from "./guards";

Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    name: "Login",
    component: () => import("../views/Login.vue"),
  },

  {
    path: "/dashboard",
    component: () => import("../views/ViewContainer.vue"),
    children: [
      {
        path: "",
        name: "Dashboard",
        component: () => import("../components/dashboard/Dashboard.vue"),
      },
    ],
  },

  {
    path: "/usuarios",
    component: () => import("../views/ViewContainer.vue"),
    children: [
      {
        path: "",
        name: "Usuários do Sistema",
        meta: { ability: "cad_user" },
        component: () => import("../components/users/Grid.vue"),
      },
    ],
  },
  {
    path: "/perfis",
    component: () => import("../views/ViewContainer.vue"),
    children: [
      {
        path: "",
        name: "Perfis e Permissões",
        meta: { ability: "cad_user", profiles: ["admin"] },
        component: () =>
          import("../components/profile/PermissionsGrid-comp.vue"),
      },
    ],
  },
  {
    path: "/listar-permissoes",
    component: () => import("../views/ViewContainer.vue"),
    children: [
      {
        path: "",
        name: "Permissões",
        meta: { ability: "cad_user" },
        component: () => import("../components/profile/Permissions-comp.vue"),
      },
    ],
  },
  {
    path: "/unidades",
    component: () => import("../views/ViewContainer.vue"),
    children: [
      {
        path: "",
        name: "Unidades de Saúde",
        meta: { ability: "cad_user" },
        component: () => import("../components/unities/Grid.vue"),
      },
    ],
  },
  {
    path: "/unidades-captadoras",
    component: () => import("../views/ViewContainer.vue"),
    children: [
      {
        path: "",
        name: "Listar Unidades Captadoras",
        meta: { ability: "cad_user" },
        component: () => import("../components/captation-unities/Grid.vue"),
      },
    ],
  },
  {
    path: "/medico-profissional",
    component: () => import("../views/ViewContainer.vue"),
    children: [
      {
        path: "",
        name: "Médicos Profissionais",
        meta: { ability: "cad_user" },
        component: () => import("../components/doctors/Grid.vue"),
      },
    ],
  },
  {
    path: "/motivos-nao-validacao",
    component: () => import("../views/ViewContainer.vue"),
    children: [
      {
        path: "",
        name: "Razões da Não Validação",
        meta: { ability: "cad_user" },
        component: () =>
          import("../components/reasons_not_validation/Grid.vue"),
      },
    ],
  },
  {
    path: "/motivos-nao-captacao",
    component: () => import("../views/ViewContainer.vue"),
    children: [
      {
        path: "",
        name: "Razões da Não Captação",
        meta: { ability: "cad_user" },
        component: () => import("../components/reasons-not-captation/Grid.vue"),
      },
    ],
  },
  {
    path: "/motivos-nao-realizacao-entrevista-familiar",
    component: () => import("../views/ViewContainer.vue"),
    children: [
      {
        path: "",
        name: "Razões da Não Realização de Entrevista Familiar",
        meta: { ability: "cad_user" },
        component: () =>
          import("../components/reasons-not-family-interview/Grid.vue"),
      },
    ],
  },
  {
    path: "/causas-morte",
    component: () => import("../views/ViewContainer.vue"),
    children: [
      {
        path: "",
        name: "Causas de Morte Neurológicas",
        meta: { ability: "cad_user" },
        component: () => import("../components/death-cause/Grid.vue"),
      },
    ],
  },
  {
    path: "/causas-morte-pcr",
    component: () => import("../views/ViewContainer.vue"),
    children: [
      {
        path: "",
        name: "Causas de Morte PCR",
        meta: { ability: "cad_user" },
        component: () => import("../components/pcr-death-cause/Grid.vue"),
      },
    ],
  },
  {
    path: "/orgaos-e-tecidos",
    component: () => import("../views/ViewContainer.vue"),
    children: [
      {
        path: "",
        name: "Orgãos e Tecidos",
        meta: { ability: "cad_user" },
        component: () => import("../components/orgons-tissues/Grid.vue"),
      },
    ],
  },
  {
    path: "/parentescos",
    component: () => import("../views/ViewContainer.vue"),
    children: [
      {
        path: "",
        name: "Parentescos",
        meta: { ability: "cad_user" },
        component: () => import("../components/kinships/Grid.vue"),
      },
    ],
  },

  {
    path: "/tipo-anexos",
    component: () => import("../views/ViewContainer.vue"),
    children: [
      {
        path: "",
        name: "Tipos de Anexos",
        meta: { ability: "cad_user" },
        component: () => import("../components/file-types/Grid.vue"),
      },
    ],
  },

  {
    path: "/comorbidades",
    component: () => import("../views/ViewContainer.vue"),
    children: [
      {
        path: "",
        name: "Comorbidades",
        meta: { ability: "cad_user" },
        component: () => import("../components/comorbidities/Grid.vue"),
      },
    ],
  },
  {
    path: "/diagnosticos-iniciais",
    component: () => import("../views/ViewContainer.vue"),
    children: [
      {
        path: "",
        name: "Diagnósticos Iniciais",
        meta: { ability: "cad_user" },
        component: () => import("../components/initial-diagnosis/Grid.vue"),
      },
    ],
  },
  {
    path: "/vinculos",
    component: () => import("../views/ViewContainer.vue"),
    children: [
      {
        path: "",
        name: "Vínculos",
        meta: { ability: "cad_user" },
        component: () => import("../components/users/LinkGrid.vue"),
      },
    ],
  },

  {
    path: "/pacientes",
    component: () => import("../views/ViewContainer.vue"),
    children: [
      {
        path: "",
        name: "Consultar Pacientes em Acompanhamento",
        meta: { ability: "list_donor" },
        component: () =>
          import(
            "../components/pacientes/provavel-doador/PatientGrid-comp.vue"
          ),
      },
    ],
  },
  {
    path: "/cadastrar-paciente",
    component: () => import("../views/ViewContainer.vue"),
    children: [
      {
        path: "",
        name: "Dados do Paciente",
        meta: { ability: "list_donor" },
        component: () =>
          import("../components/pacientes/provavel-doador/Pacientes-comp.vue"),
      },
    ],
  },
  {
    path: "/informes-clinicos",
    component: () => import("../views/ViewContainer.vue"),
    children: [
      {
        path: "",
        name: "Informes Clínicos",
        meta: { ability: "list_donor" },
        component: () =>
          import(
            "../components/pacientes/provavel-doador/informesClínicos/InformesClinicos.vue"
          ),
      },
    ],
  },
  {
    path: "/anexos",
    component: () => import("../views/ViewContainer.vue"),
    children: [
      {
        path: "",
        name: "Avaliação Final",
        meta: { ability: "list_donor" },
        component: () =>
          import(
            "../components/pacientes/provavel-doador/anexos/Anexos-comp.vue"
          ),
      },
    ],
  },
  {
    path: "/receptor",
    component: () => import("../views/ViewContainer.vue"),
    children: [
      {
        path: "",
        name: "Receptores",
        meta: { ability: "list_donor" },
        component: () => import("../components/pacientes/receptor/Index.vue"),
      },
    ],
  },
  {
    path: "/cadastrar-receptor",
    component: () => import("../views/ViewContainer.vue"),
    children: [
      {
        path: "",
        name: "Receptores",
        meta: { ability: "list_donor" },
        component: () =>
          import("../components/pacientes/receptor/Receptor.vue"),
      },
    ],
  },
  {
    path: "/cadastrar-exames",
    component: () => import("../views/ViewContainer.vue"),
    children: [
      {
        path: "",
        name: "Exames de Entrada",
        meta: { ability: "list_donor" },
        component: () =>
          import(
            "../components/pacientes/provavel-doador/examesEntrada/ExamesEntrada-comp.vue"
          ),
      },
    ],
  },
  {
    path: "/cadastrar-captacao",
    component: () => import("../views/ViewContainer.vue"),
    children: [
      {
        path: "",
        name: "Captação de Orgãos",
        meta: { ability: "list_donor" },
        component: () =>
          import("../components/pacientes/doador/captacoes/CaptationTabs.vue"),
      },
    ],
  },
  {
    path: "/validacao-doador-pcr",
    component: () => import("../views/ViewContainer.vue"),
    children: [
      {
        path: "",
        name: "Avaliação Potencial Doador de Córneas - PCR",
        meta: { ability: "list_donor" },
        component: () =>
          import(
            "../components/pacientes/provavel-doador/validacaoDoador/ValidacaoPCR-comp.vue"
          ),
      },
    ],
  },
  {
    path: "/disponibilizacao-doador",
    component: () => import("../views/ViewContainer.vue"),
    children: [
      {
        path: "",
        name: "Disponibilização",
        meta: { ability: "list_donor" },
        component: () =>
          import(
            "../components/pacientes/doador/captacoes/Disponibilizacao-comp.vue"
          ),
      },
    ],
  },
  {
    path: "/disponibilizacao",
    component: () => import("../views/ViewContainer.vue"),
    children: [
      {
        path: "",
        name: "Disponibilização",
        meta: { ability: "list_donor" },
        component: () =>
          import(
            "../components/pacientes/doador/disponibilizacao/TableDisponibilizacao-comp.vue"
          ),
      },
    ],
  },
  {
    path: "/escala-glasgow",
    component: () => import("../views/ViewContainer.vue"),
    children: [
      {
        path: "",
        name: "Cadastrar/Acompanhar Escala Glasgow",
        meta: { ability: "list_donor" },
        component: () =>
          import(
            "../components/pacientes/provavel-doador/escalaGlasgow/EscalaGlasgow-comp.vue"
          ),
      },
    ],
  },

  {
    path: "/motivos-recusa-familiar",
    component: () => import("../views/ViewContainer.vue"),
    children: [
      {
        path: "",
        name: "Motivos de Recusa Familiar",
        component: () =>
          import("../components/reasons-family-refusal/Grid.vue"),
      },
    ],
  },

  {
    path: "/dados-morte",
    component: () => import("../views/ViewContainer.vue"),
    children: [
      {
        path: "",
        name: "Dados da Morte",
        meta: { ability: "list_donor" },
        component: () =>
          import(
            "../components/pacientes/provavel-doador/mortePCR/MortePCRForm-comp.vue"
          ),
      },
    ],
  },
  {
    path: "/validacao-doador-me",
    component: () => import("../views/ViewContainer.vue"),
    children: [
      {
        path: "",
        name: "Validação do Doador - ME",
        meta: { ability: "list_donor" },
        component: () =>
          import(
            "../components/pacientes/provavel-doador/validacaoDoador/ValidacaoDoador.vue"
          ),
      },
    ],
  },
  {
    path: "/aceite-familiar",
    component: () => import("../views/ViewContainer.vue"),
    children: [
      {
        path: "",
        name: "Aceite Familiar",
        meta: { ability: "list_donor" },
        component: () =>
          import(
            "../components/pacientes/provavel-doador/validacaoDoador/AceiteFamiliar.vue"
          ),
      },
    ],
  },
  {
    path: "/orgaos-captados",
    component: () => import("../views/ViewContainer.vue"),
    children: [
      {
        path: "",
        name: "Orgãos Captados",
        meta: { ability: "list_donor" },
        component: () =>
          import(
            "../components/pacientes/doador/orgaos-captados/OrgaosCaptadosGrid.vue"
          ),
      },
    ],
  },

  {
    path: "/sorologia",
    component: () => import("../views/ViewContainer.vue"),
    children: [
      {
        path: "",
        name: "Sorologia",
        meta: { ability: "cad_serology" },
        component: () =>
          import(
            "../components/pacientes/provavel-doador/sorologia/TableSorologia-comp.vue"
          ),
      },
    ],
  },
  {
    path: "/cadastrar-sorologia",
    component: () => import("../views/ViewContainer.vue"),
    children: [
      {
        path: "",
        name: "Sorologia",
        meta: { ability: "cad_serology" },
        component: () =>
          import(
            "../components/pacientes/provavel-doador/sorologia/SorologiaForm.vue"
          ),
      },
    ],
  },
  {
    path: "/anexos-sorologia",
    component: () => import("../views/ViewContainer.vue"),
    children: [
      {
        path: "",
        name: "Avaliação Final",
        meta: { ability: "cad_serology" },
        component: () =>
          import(
            "../components/pacientes/provavel-doador/sorologia/AnexosSorologia.vue"
          ),
      },
    ],
  },

  {
    path: "/grupo-sanguineo",
    component: () => import("../views/ViewContainer.vue"),
    children: [
      {
        path: "",
        name: "Grupos Sanguíneos",
        meta: { ability: "cad_blood_group" },
        component: () =>
          import(
            "../components/pacientes/provavel-doador/sorologia/grupos_sanguineos/BloodGroupTable.vue"
          ),
      },
    ],
  },
  {
    path: "/cadastrar-grupo-sanguineo",
    component: () => import("../views/ViewContainer.vue"),
    children: [
      {
        path: "",
        name: "Grupo Sanguíneo",
        meta: { ability: "cad_blood_group" },
        component: () =>
          import(
            "../components/pacientes/provavel-doador/sorologia/grupos_sanguineos/BloodGroupForm.vue"
          ),
      },
    ],
  },

  {
    path: "/logs",
    component: () => import("../views/ViewContainer.vue"),
    children: [
      {
        path: "",
        name: "Logs",
        meta: { ability: "history_logs" },
        component: () => import("../components/logs/LogTable.vue"),
      },
    ],
  },
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes,
});

router.beforeEach(authGuard);

export default router;
